export function textCode(elem, parent) {
  var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
  var speed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 95;
  var code = "!<>€=+*^?#|@$%^$@!&*?><";
  var origText = elem.textContent;
  function randomText() {
    var letters = elem.textContent.split('');
    var codeText = [];
    for (var i = 0; i < letters.length; i++) {
      codeText.push(code.charAt(Math.floor(Math.random() * code.length)));
    }
    elem.textContent = codeText.join('');
  }
  if (parent == undefined) parent = elem;
  parent.addEventListener('mouseover', function (e) {
    var interval = setInterval(function () {
      randomText();
    }, speed);
    setTimeout(function () {
      clearInterval(interval);
      elem.textContent = origText;
      elem.addEventListener('mouseout', function (e) {
        clearInterval(interval);
        elem.textContent = origText;
      });
    }, time);
  });
}